import { Divider, Container } from '@optimus-web/core';

export const TableDivider = () => (
    <Container padding={['200', '0']}>
        <Divider size="large" />
    </Container>
);
